import service from "@/api/service";
import { GetResponse } from "@/api/stamp-rank/response";
import { GetRequest } from "@/api/stamp-rank/request";

/**
 * スタンプカードランク設定取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-stamp-rank", getRequest);
  return response.data as GetResponse;
}
